import { render, staticRenderFns } from "./Collect.vue?vue&type=template&id=7e3ebd52&scoped=true&lang=pug&"
import script from "./Collect.vue?vue&type=script&lang=ts&"
export * from "./Collect.vue?vue&type=script&lang=ts&"
import style0 from "./Collect.vue?vue&type=style&index=0&id=7e3ebd52&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e3ebd52",
  null
  
)

export default component.exports